/**
 * 学习乐园 · 不等式推理（game-budengshi.js）
 * ============================================================
 * 「排序与序列」组第四作（烧脑收官）：只给「小舟比小禾高」这类线索，
 * 推出五个人的完整排队顺序——不等式推理链的具象化（比身高排队）。
 * 与排排序互补：排排序的顺序是「看见的」，这里的顺序是「推出来的」；
 * 与比大小互补：那边比较对象本身，这边比较关系推出全序。
 *
 * 出题底线（唯一解承诺）：每一局的线索集都经过全排列枚举校验——
 * 恰好只有一种排法满足全部线索才出题。推理题出多解是伪题。
 *
 * 反馈底线（栏目同款）：「查一查」按线索顺序找出第一条被违反的，
 * 引用线索原文、指出两个人现在的站位、讲清矛盾在哪——不惩罚，
 * 交换次数与查询次数如实计入。
 *
 * 口径：三档 4 人 4 线索（默认，铁律：默认档必须最简单）/ 5 人 6 线索 /
 * 5 人 5 线索（最少线索钉死全序，最烧脑）；计时；只存本机。
 *
 * 冒烟钩子：window.STBudengshi 暴露纯引擎（levelSpec / gen / ok /
 * firstConflict / clueText）。
 */
(function (global) {
  'use strict';

  var PREF_KEY = 'study-budengshi';
  var RECORD_KEY = 'study-budengshi-record';

  var NAMES = ['小舟', '小禾', '小川', '小岩', '小林', '小羽', '小泉'];

  var LEVELS = {
    1: { label: '入门 4 人', hint: '默认档 · 4 条线索', people: 4, clues: 4 },
    2: { label: '进阶 5 人', hint: '6 条线索', people: 5, clues: 6 },
    3: { label: '挑战 5 人', hint: '仅 5 条线索钉死', people: 5, clues: 5 },
  };

  /* ============ 小工具 ============ */

  function rint(n) { return Math.floor(Math.random() * n); }
  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = rint(i + 1);
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  /* ============ 纯引擎（无 DOM） ============ */

  function levelSpec(level) {
    var lv = LEVELS[level] ? level : 1;
    return { level: lv, people: LEVELS[lv].people, clues: LEVELS[lv].clues };
  }

  // order 是「人名索引的排列」：order[0] 第 1 高；pos = order.indexOf(who)
  function pos(order, who) { return order.indexOf(who); }

  function clueText(clue, names) {
    return names[clue[0]] + '比' + names[clue[1]] + '高';
  }

  /** 全部线索是否满足（order[0] 最靠前 = 最高） */
  function ok(order, clues) {
    return clues.every(function (c) {
      return pos(order, c[0]) < pos(order, c[1]);
    });
  }

  /**
   * 第一条被违反的线索（按线索清单顺序）——查一查的讲解依据。
   * 没有违反返回 null。
   */
  function firstConflict(order, clues) {
    for (var i = 0; i < clues.length; i++) {
      var c = clues[i];
      if (pos(order, c[0]) > pos(order, c[1])) {
        return { idx: i, a: c[0], b: c[1], pa: pos(order, c[0]), pb: pos(order, c[1]) };
      }
    }
    return null;
  }

  /** 唯一解校验：枚举 k! 全排列，满足全部线索的排法恰好 1 种 */
  function countSolutions(people, clues) {
    var idx = [];
    for (var i = 0; i < people; i++) idx.push(i);
    var count = 0;
    (function permute(arr, used) {
      if (count > 1) return;   // 剪枝：超过 1 种即可判负
      if (arr.length === people) {
        if (ok(arr, clues)) count++;
        return;
      }
      for (var i = 0; i < people; i++) {
        if (used[i]) continue;
        used[i] = true;
        arr.push(i);
        permute(arr, used);
        arr.pop();
        used[i] = false;
      }
    })([], {});
    return count;
  }

  /**
   * 出一局：随机答案序 + 随机线索集，经唯一解校验（恰 1 种排法）。
   * 不唯一就换一批线索重试；线索用尽仍不唯一则加线索兜底（理论不可达：
   * 全部对关系必然唯一）。线索数 = 档位口径。
   */
  function gen(level) {
    var spec = levelSpec(level);
    var k = spec.people;
    var names = shuffle(NAMES).slice(0, k);
    var order = shuffle(idxArr(k));   // 答案：order[0] 最高

    var pairs = [];
    for (var i = 0; i < k; i++) {
      for (var j = 0; j < k; j++) {
        if (i === j) continue;
        // 线索统一存「高者在前」：pos 答案序里 i 靠前则 [i, j]
        if (pos(order, i) < pos(order, j)) pairs.push([i, j]);
      }
    }

    var want = spec.clues;
    for (var t = 0; t < 500; t++) {
      var cand = shuffle(pairs).slice(0, Math.min(want, pairs.length));
      if (countSolutions(k, cand) === 1) {
        return { level: spec.level, names: names, order: order, clues: cand };
      }
      if (t === 499 && want < pairs.length) {   // 兜底：加线索再来
        want++;
        t = 0;
      }
    }
    /* 理论不可达兜底：全量对关系必然唯一 */
    return { level: spec.level, names: names, order: order, clues: pairs };
  }

  function idxArr(k) {
    var a = [];
    for (var i = 0; i < k; i++) a.push(i);
    return a;
  }

  /* ============ UI：状态与工具 ============ */

  var root = null;
  var ui = {};
  var S = {
    level: 1, g: null, order: [],
    swaps: 0, checks: 0, elapsed: 0, timer: null, done: false,
    soundOn: true, resetArm: false, resetTimer: null, sel: -1,
  };

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* —— 音效（WebAudio 本地合成，同栏口味）—— */
  /* 手机外放响度补偿（口径统一，由 scripts/boost-sfx-mobile.mjs 批量写入）：
     手机小喇叭对 500Hz 以下钝感、超短音感知响度低——触屏设备把提示音增益翻倍、
     低于 500Hz 的音移高八度、衰减拉长；桌面/耳机维持原响度。 */
  var SFX_MOBILE = false;
  try {
    SFX_MOBILE = (global.matchMedia && global.matchMedia('(pointer: coarse)').matches) ||
      (global.navigator && global.navigator.maxTouchPoints > 0);
  } catch (e) { /* 检测不可用按桌面处理 */ }
  var actx = null;
  function sfx(kind) {
    if (!S.soundOn) return;
    try {
      var AC = global.AudioContext || global.webkitAudioContext;
      if (!AC) return;
      if (!actx) actx = new AC();
      if (actx.state === 'suspended' && actx.resume) actx.resume();
      var t = actx.currentTime;
      var seq;
      if (kind === 'ok') seq = [[523, 0], [659, 0.07]];
      else if (kind === 'bad') seq = [[196, 0], [185, 0.09]];
      else seq = [[523, 0], [659, 0.1], [784, 0.2], [1046, 0.3]];   // win
      for (var i = 0; i < seq.length; i++) {
        var o = actx.createOscillator();
        var g = actx.createGain();
        o.type = 'triangle';
        o.frequency.setValueAtTime(SFX_MOBILE && seq[i][0] < 500 ? seq[i][0] * 2 : seq[i][0], t + seq[i][1]);
        g.gain.setValueAtTime(0.0001, t + seq[i][1]);
        g.gain.exponentialRampToValueAtTime(SFX_MOBILE ? 0.42 : 0.18, t + seq[i][1] + 0.01);
        g.gain.exponentialRampToValueAtTime(0.0001, t + seq[i][1] + (SFX_MOBILE ? 0.2 : 0.14));
        o.connect(g);
        g.connect(actx.destination);
        o.start(t + seq[i][1]);
        o.stop(t + seq[i][1] + (SFX_MOBILE ? 0.26 : 0.16));
      }
    } catch (e) { /* 音频不可用静默 */ }
  }

  /* —— 偏好与成绩 —— */
  function save() {
    try { localStorage.setItem(PREF_KEY, JSON.stringify({ v: 1, level: S.level, soundOn: S.soundOn })); }
    catch (e) { /* 存储不可用静默 */ }
  }
  function restorePrefs() {
    try {
      var d = JSON.parse(localStorage.getItem(PREF_KEY) || '{}');
      if (d && d.v === 1) {
        if (LEVELS[d.level]) S.level = d.level;
        S.soundOn = d.soundOn !== false;
      }
    } catch (e) { /* 忽略脏数据 */ }
  }
  function loadRecord() {
    try {
      var r = JSON.parse(localStorage.getItem(RECORD_KEY) || '{}');
      return r && typeof r === 'object' && !Array.isArray(r) ? r : {};
    } catch (e) { return {}; }
  }

  /* ============ 渲染 ============ */

  function fmtTime(sec) {
    var m = Math.floor(sec / 60), s = sec % 60;
    return m + ' 分 ' + (s < 10 ? '0' : '') + s + ' 秒';
  }
  function fmtTimeShort(sec) {
    var m = Math.floor(sec / 60), s = sec % 60;
    return m ? m + ' 分 ' + (s < 10 ? '0' : '') + s + ' 秒' : s + ' 秒';
  }

  function renderLevels() {
    ui.levels.textContent = '';
    [1, 2, 3].forEach(function (lv) {
      var b = el('button', 'st-llk-pack-btn' + (S.level === lv ? ' is-active' : ''));
      b.type = 'button';
      b.setAttribute('data-level', String(lv));
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', S.level === lv ? 'true' : 'false');
      b.appendChild(el('span', 'st-llk-pack-name', LEVELS[lv].label));
      b.appendChild(el('small', 'st-llk-pack-hint', LEVELS[lv].hint));
      b.addEventListener('click', function () {
        if (S.level === lv) return;
        S.level = lv;
        renderLevels();
        newGame();
        save();
      });
      ui.levels.appendChild(b);
    });
  }

  function renderClues(conflictIdx) {
    ui.clues.textContent = '';
    S.g.clues.forEach(function (c, i) {
      var li = el('li', 'st-bd-clue' + (conflictIdx === i ? ' is-conflict' : ''));
      li.appendChild(el('span', 'st-bd-clue-no', String(i + 1)));
      li.appendChild(el('span', 'st-bd-clue-text', clueText(c, S.g.names)));
      ui.clues.appendChild(li);
    });
  }

  function renderBoard() {
    ui.board.textContent = '';
    for (var i = 0; i < S.order.length; i++) {
      (function (slot) {
        var d = el('div', 'st-bd-slot');
        d.appendChild(el('span', 'st-bd-slot-no', '第 ' + (slot + 1) + ' 位'));
        var name = S.order[slot];
        var b = el('button', 'st-bd-card' + (S.sel === slot ? ' is-sel' : ''));
        b.type = 'button';
        b.textContent = S.g.names[name];
        b.setAttribute('data-name', S.g.names[name]);
        b.setAttribute('aria-label', '第 ' + (slot + 1) + ' 位是 ' + S.g.names[name]
          + (S.sel === slot ? '，已选中，再点另一张交换' : S.sel >= 0 ? '，与已选中的交换' : '，点它开始换位'));
        b.addEventListener('click', function () { onCard(slot); });
        d.appendChild(b);
        ui.board.appendChild(d);
      })(i);
    }
  }

  function renderStatus() {
    if (S.done) return;
    ui.status.textContent = '交换 ' + S.swaps + ' 次 · 用时 ' + fmtTime(S.elapsed)
      + (S.sel >= 0 ? ' · 已选「' + S.g.names[S.order[S.sel]] + '」，再点另一位交换' : '');
  }

  function renderNote(msg, tone) {
    ui.note.textContent = msg;
    ui.note.className = 'st-llk-note' + (tone ? ' is-' + tone : '');
  }

  function recordStat(label, value) {
    var d = el('div', 'st-llk-stat');
    d.appendChild(el('span', 'st-llk-stat-label', label));
    d.appendChild(el('strong', 'st-llk-stat-value', value));
    return d;
  }

  function renderRecord() {
    var box = ui.record;
    box.textContent = '';
    var rec = loadRecord();
    var any = [1, 2, 3].some(function (lv) { return rec[lv] && rec[lv].wins; });
    if (!any) {
      box.className = 'st-llk-record is-empty';
      box.appendChild(el('p', 'st-llk-record-empty', '这个档还没通关过——推出正确队形，这里记下你的最好成绩。'));
      return;
    }
    box.className = 'st-llk-record';
    [1, 2, 3].forEach(function (lv) {
      var r = rec[lv];
      box.appendChild(recordStat(LEVELS[lv].label.replace(' ', ''),
        r && r.wins ? (r.bestTime ? fmtTimeShort(r.bestTime) : '—') + ' · ' + r.wins + ' 次' : '—'));
    });
  }

  function renderButtons() {
    ui.resetBtn.classList.toggle('is-arm', S.resetArm);
    ui.resetBtn.textContent = S.resetArm ? '再点一次确认重置' : '重置成绩';
  }

  /* ============ 交互 ============ */

  /* 点两下交换（与排排序同一套交互心智）：先点选一位，再点另一位互换 */
  function onCard(slot) {
    if (S.done) return;
    if (S.sel < 0) {
      S.sel = slot;
      sfx('ok');
      renderBoard();
      renderStatus();
      return;
    }
    if (S.sel === slot) {
      S.sel = -1;   // 再点自己 = 取消选择
      renderBoard();
      renderStatus();
      return;
    }
    var t = S.order[S.sel];
    S.order[S.sel] = S.order[slot];
    S.order[slot] = t;
    S.sel = -1;
    S.swaps++;
    sfx('ok');
    renderBoard();
    renderStatus();
    if (ok(S.order, S.g.clues)) { finish(); return; }
  }

  /* 查一查：按线索顺序找第一条被违反的，引用原文讲清矛盾 */
  function checkHint() {
    if (S.done) return;
    S.checks++;
    var c = firstConflict(S.order, S.g.clues);
    if (!c) {   // 理论上出现即通关（onCard 已自动判），防御
      finish();
      return;
    }
    var an = S.g.names[c.a], bn = S.g.names[c.b];
    renderClues(c.idx);
    renderNote('第 ' + (c.idx + 1) + ' 条线索「' + clueText(S.g.clues[c.idx], S.g.names)
      + '」被违反了：' + an + ' 现在站第 ' + (c.pa + 1) + ' 位、' + bn + ' 站第 ' + (c.pb + 1)
      + ' 位——位次越靠前个子越高，' + an + ' 应该站在 ' + bn + ' 前面。把 ' + an + ' 挪到 ' + bn
      + ' 前面去，再查。（已查 ' + S.checks + ' 次）', 'warn');
    sfx('bad');
  }

  function startTimer() {
    stopTimer();
    S.elapsed = 0;
    S.timer = setInterval(function () {
      if (S.done) return;
      S.elapsed++;
      renderStatus();
    }, 1000);
  }
  function stopTimer() {
    if (S.timer) { clearInterval(S.timer); S.timer = null; }
  }

  function finish() {
    S.done = true;
    stopTimer();
    sfx('win');
    var rec = loadRecord();
    var cur = rec[S.level] || { plays: 0, wins: 0, bestTime: 0, bestSwaps: null };
    cur.plays++;
    cur.wins++;
    var isBest = !cur.bestTime || S.elapsed < cur.bestTime;
    if (isBest) {
      cur.bestTime = S.elapsed;
      cur.bestSwaps = S.swaps;
    }
    rec[S.level] = cur;
    try { localStorage.setItem(RECORD_KEY, JSON.stringify(rec)); } catch (e) { /* 静默 */ }
    ui.status.textContent = '队形正确！' + S.swaps + ' 次交换，用时 ' + fmtTime(S.elapsed)
      + '，查了 ' + S.checks + ' 次。' + (isBest ? '这是这个档的最好成绩。' : '（最好成绩 ' + fmtTime(cur.bestTime) + '）');
    ui.status.className = 'st-status is-over';
    renderNote('线索全部满足——你用的是「由线索缩小范围」的推理，其中最有力的一招是传递性：'
      + '甲比乙高、乙比丙高，甲就一定比丙高，哪怕线索里从没直接说过他们俩。点「换一题」再来。', 'ok');
    renderRecord();
    renderButtons();
  }

  function newGame() {
    var spec = levelSpec(S.level);
    S.level = spec.level;
    S.g = gen(spec.level);
    // 槽位乱序摆人（不是答案序）：从答案序出发洗一遍
    S.order = shuffle(S.g.order);
    // 洗出恰为答案序（极小概率）就再洗一次
    if (ok(S.order, S.g.clues)) S.order = shuffle(S.g.order);
    S.swaps = 0;
    S.checks = 0;
    S.sel = -1;
    S.done = false;
    S.resetArm = false;
    if (S.resetTimer) { clearTimeout(S.resetTimer); S.resetTimer = null; }
    ui.status.className = 'st-status';
    renderStatus();
    renderNote('把 ' + S.g.names.length + ' 个人排成从高到矮的一列：点两位交换位置，让每条线索都成立。'
      + '这局的线索恰好只有一种排法满足——推理题不玩多解。', '');
    renderClues(null);
    renderBoard();
    renderRecord();
    renderButtons();
    startTimer();
  }

  function resetRecord() {
    if (!S.resetArm) {
      S.resetArm = true;
      renderButtons();
      if (S.resetTimer) clearTimeout(S.resetTimer);
      S.resetTimer = setTimeout(function () { S.resetArm = false; S.resetTimer = null; renderButtons(); }, 3000);
      return;
    }
    S.resetArm = false;
    if (S.resetTimer) { clearTimeout(S.resetTimer); S.resetTimer = null; }
    try { localStorage.setItem(RECORD_KEY, JSON.stringify({})); } catch (e) { /* 静默 */ }
    renderRecord();
    renderButtons();
    renderNote('已重置不等式推理的本机成绩。', '');
  }

  /* 音效选择器（口径同汉诺塔） */
  function bindSoundPicker() {
    var btns = root.querySelectorAll('[data-st-sound]');
    for (var i = 0; i < btns.length; i++) {
      (function (b) {
        b.addEventListener('click', function () {
          S.soundOn = b.getAttribute('data-st-sound') === 'on';
          syncSoundPicker();
          save();
          if (S.soundOn) sfx('ok');
        });
      })(btns[i]);
    }
    syncSoundPicker();
  }
  function syncSoundPicker() {
    var btns = root.querySelectorAll('[data-st-sound]');
    for (var i = 0; i < btns.length; i++) {
      var on = (btns[i].getAttribute('data-st-sound') === 'on') === S.soundOn;
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-checked', on ? 'true' : 'false');
    }
  }

  /* ============ boot ============ */

  function boot() {
    root = document.querySelector('[data-st-game]');
    if (!root) return;
    ui.board = root.querySelector('[data-st-bd-board]');
    ui.clues = root.querySelector('[data-st-bd-clues]');
    ui.status = root.querySelector('[data-st-status]');
    ui.note = root.querySelector('[data-st-note]');
    ui.levels = root.querySelector('[data-st-bd-levels]');
    ui.record = root.querySelector('[data-st-record]');
    ui.newBtn = root.querySelector('[data-st-new]');
    ui.checkBtn = root.querySelector('[data-st-check]');
    ui.resetBtn = root.querySelector('[data-st-reset]');
    if (!ui.board) return;

    restorePrefs();
    renderLevels();
    bindSoundPicker();

    ui.newBtn.addEventListener('click', function () { newGame(); });
    ui.checkBtn.addEventListener('click', checkHint);
    ui.resetBtn.addEventListener('click', resetRecord);

    newGame();
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }

  /* ============ 冒烟与单测钩子 ============ */

  global.STBudengshi = {
    levelSpec: levelSpec,
    gen: gen,
    ok: ok,
    firstConflict: firstConflict,
    clueText: clueText,
    countSolutions: countSolutions,
  };
})(typeof window !== 'undefined' ? window : this);
